import React, { useEffect, useRef, useState } from 'react'
import { SalariesTableVM } from '../../Structure/ViewModels/Marketer/SalariesTableVM'
import { Accordion, Row } from 'react-bootstrap'

const SalariesTable = (props:{id:string}) => {
    const [vm , setVm ] = useState<{viewModel:SalariesTableVM}>({viewModel: new SalariesTableVM(props.id)})
    const control = vm.viewModel
    useEffect(()=>{
        control.subscribeUpdate(setVm)
        control.getData()
    },[])

    useEffect(() => {
        const handleScroll = () => {
            const element = scrollableRef.current;
            if (element && element.scrollTop + element.clientHeight >= element.scrollHeight) {
                control.addData()
            }
        };

        const element = scrollableRef.current;
        if (element) {
            element.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (element) {
                element.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    const scrollableRef = useRef<HTMLDivElement | null>(null);

    const status = [
        { value: 'settled', label: 'فى الانتظار' },
        { value: 'done', label: 'تم السداد' },
      ];


  return (
    <Accordion>
    <Accordion.Item eventKey="1" className=' overflow-hidden' >
        <Accordion.Header className='overflow-auto'>
            <h4>الرواتب</h4>
        </Accordion.Header>
        <Accordion.Body ref={scrollableRef} className='px-0 px-lg-3 overflow-y-auto' style={{height:'500px'}}>
            {
                control.Show(
            <Row className='w-100 mx-0'>
                <div className='rounded-3 p-0'>
                    <div className='d-flex flex-wrap justify-content-end'>
                        {/* <div className='d-flex  flex-wrap'>

                            <div className='d-flex flex-column justify-content-center p-2'>
                                <CustomSelect list={status} selected={control.Status} placeHolder='حالة السداد' onSelect={a=>control.Status = a}/>
                            </div>
                            <div className='d-flex flex-column justify-content-center p-2'>
                                <div className='d-flex my-auto'>
                                    <h6 className='px-2 my-auto'>من</h6>
                                    <input type="date" className='input-field p-2 c-pointer' value={control.From} onChange={a=>control.From = a.target.value}  />
                                </div>

                            </div>
                            <div className='d-flex flex-column justify-content-center p-2'>
                                <div className='d-flex my-auto'>
                                    <h6 className='px-2 my-auto'>الى</h6>
                                    <input type="date" className='input-field p-2 c-pointer' value={control.To} onChange={a=>control.To = a.target.value} />
                                </div>

                            </div>
                            <div className='d-flex flex-column justify-content-center p-2'>
                                <Search hasNoSelect  onSearch={a=>{control.Search=a; control.getData()}}/>
                            </div>
                        </div> */}
                    </div>
                    <div className='d-flex p-3 overflow-x-auto'>
                        <table className='w-100 text-center' style={{minWidth:'500px'}}>
                            <tr className='txt-color-I bg-light-gray'>
                                <th>الحالة</th>
                                <th> النهائي</th>
                                <th>التاريخ</th>
                                <th>القيمة</th>
                                <th>التارجت</th>
                                <th>الخصم</th>
                                <th>البونص</th>
                                <th>ملاحظات</th>
                            </tr>
                            {
                            control.Data.map((item,index)=>(
                                <tr key={index} style={{background:index%2?'white':'rgba(200,200,200,0.2)'}}>
                                    <td>{status.find(a=>a.value===item.status)?.label}</td>
                                    <th> {item.finalSalary}</th>
                                    <th>{item.transfer_date}</th>
                                    <td>{item.deserved}</td>
                                    <td>{item.genTarget} + {item.target||'0'}</td>
                                    <td>{item.genCuts} + {item.target||'0'}</td>
                                    <td>{item.genBounses} + {item.target||'0'}</td>
                                    <td>{item.notes}</td>
                                </tr>
                            ))
                            }
                        </table>

                    </div>
                </div>
            </Row>)
            }
        </Accordion.Body>
    </Accordion.Item>
</Accordion>
  )
}

export default SalariesTable
